import { render, staticRenderFns } from "./newclass.vue?vue&type=template&id=71a32696&scoped=true"
import script from "./newclass.vue?vue&type=script&lang=js"
export * from "./newclass.vue?vue&type=script&lang=js"
import style0 from "./newclass.vue?vue&type=style&index=0&id=71a32696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a32696",
  null
  
)

export default component.exports